import { cn } from '@divlab/divanui';

import styles from './SkeletWave.module.css';

import type { FC } from 'react';

export interface SkeletWaveProps {
  className?: string;
  theme?: 'light' | 'gray';
  width?: 'fixed' | 'auto';
}

const SkeletWave: FC<SkeletWaveProps> = (props) => {
  const { className, theme = 'gray', width = 'fixed', ...restProps } = props;

  return (
    <div
      {...restProps}
      className={cn(
        styles.wave,
        {
          [styles.light]: theme === 'light',
          [styles.gray]: theme === 'gray',
          [styles.autoWidth]: width === 'auto',
        },
        className,
      )}
    ></div>
  );
};

export default SkeletWave;
